import {Observable, Subscription} from 'rxjs';

import Frame          from '../../Frame/Frame';
import ICaptionsStore from '../Interfaces/ICaptionsStore';

const subscribeToFrameStoreUpdate = (
    frameUpdate$: Observable<Frame>,
    captionsStore: ICaptionsStore
): Subscription =>
    frameUpdate$
        .subscribe(nextFrame => captionsStore.actions.deriveFrame(nextFrame));

export default subscribeToFrameStoreUpdate;